// screens2.js — faithful screens #3-5 for the hero showcase (ported from
// website2-screens2.jsx): Bookings inbox, Clients & pets, Messages + AI booking.
import React from 'react'
import { N2Ic, NIc, NPaw } from './icons'
import { N2Cursor, useN2Phases } from './shell'

/* ── 3 · Bookings — the real Requests inbox ── */
const SB_REQS = [
	{ id: 'r1', client: 'Harper Quinn', isNew: true, sub: 'Requested 2h ago · (415) 555-0132',
		when: 'Mon, Jul 20 · 9:00 AM', tot: '1 pet · 80 min · ', total: '$119', pref: null, conflict: null,
		pets: [{ name: 'Waffles', breed: 'Goldendoodle', pic: 'doodle', svc: 'Full Groom — Medium', mins: 80, price: '$119', addons: ['Teeth Brushing', 'Blueberry Facial'] }],
		note: 'First groom since adoption — she’s shy but very sweet. Please go slow with the dryer.' },
	{ id: 'r2', client: 'Kevin Tran', isNew: false, sub: 'Requested 4h ago · (415) 555-0178',
		when: 'Mon, Jul 20 · 10:00 AM', tot: '2 pets · 120 min · ', total: '$181', pref: 'Prefers Ashley',
		conflict: { pet: 'Scout', svc: 'Bath & Brush', span: '11:30 AM–12:10 PM', gr: 'Jordan' },
		pets: [{ name: 'Milo', breed: 'Pembroke Welsh Corgi', pic: 'corgi', svc: 'Bath & Brush', mins: 50, price: '$77', addons: ['Ear Cleaning', 'Nail Trim'] },
			{ name: 'Peaches', breed: 'Cavalier King Charles Spaniel', pic: 'cavalier', svc: 'Full Groom — Small', mins: 70, price: '$104', addons: ['Teeth Brushing', 'De-shedding Treatment', 'Blueberry Facial'] }],
		note: null },
	{ id: 'r3', client: 'Renee Cho', isNew: false, sub: 'Requested yesterday · (415) 555-0114',
		when: 'Wed, Jul 22 · 10:00 AM', tot: '1 pet · 100 min · ', total: '$147', pref: null, conflict: null,
		pets: [{ name: 'Cooper', breed: 'Labrador Retriever', pic: 'lab', svc: 'Full Groom — Large', mins: 100, price: '$147', addons: ['De-shedding Treatment', 'Nail Trim'] }],
		note: 'Cooper mats behind his ears — please double-check that spot.' }
]
function SbPetBlock({ p }) {
	return (
		<div className="sb-pet">
			<SclPetPic kind={p.pic} size={30} />
			<div className="sb-pet-mid">
				<div className="sb-pet-id"><strong>{p.name}</strong><span className="sb-breed">{p.breed}</span></div>
				<div className="sb-pet-svc"><span className="sb-svcname">{p.svc}</span><span className="sb-mins">{p.mins} min</span></div>
				{p.addons.length ? (
					<ul className="sb-addons">
						{p.addons.map((a) => <li className="sb-addon" key={a}><span className="sb-addon-mark">+</span><span>{a}</span></li>)}
					</ul>
				) : null}
			</div>
			<span className="sb-pet-price">{p.price}</span>
		</div>
	)
}
function SbReq({ r, gone = false, phase = 'idle' }) {
	return (
		<article className={'sb-req' + (gone ? ' gone' : '')}>
			<header className="sb-req-head">
				<div className="sb-req-id">
					<div className="sb-idline">
						<strong>{r.client}</strong>
						{r.isNew ? <span className="nm-flag first"><N2Ic name="spark" size={11} sw={2} />New client</span> : null}
						{r.pets.length > 1 ? <span className="nm-flag multi"><NPaw size={11} />{r.pets.length} pets</span> : null}
					</div>
					<span className="sb-subline">{r.sub}</span>
				</div>
				<div className="sb-reqsum">
					<span className={'sb-reqtime' + (r.conflict ? ' conflict' : '')}><NIc name={r.conflict ? 'warn' : 'calendar'} size={13} sw={1.7} /><span>{r.when}</span></span>
					<span className="sb-rowtot">{r.tot}<strong>{r.total}</strong></span>
					{r.pref ? <span className="sb-rowpref"><NIc name="user" size={11} sw={1.8} />{r.pref}</span> : null}
				</div>
				<div className="sb-reqact">
					<span className={'sb-approve' + (phase === 'press' ? ' pressed' : '')}><N2Ic name="check" size={13} sw={2.6} />Accept</span>
					<span className="sb-declbtn">Decline</span>
					<span className="sb-iconbtn"><NIc name="chat" size={14} sw={1.6} /></span>
					{phase === 'cursor' || phase === 'press' ? <N2Cursor show={true} press={phase === 'press'} x="44px" y="58%" /> : null}
				</div>
			</header>
			{r.conflict ? (
				<div className="sb-conflictbar">
					<NIc name="warn" size={14} sw={1.7} />
					<span>Possible conflict — overlaps <strong>{r.conflict.pet}</strong>’s {r.conflict.svc}, {r.conflict.span} with {r.conflict.gr}. Accepting will double-book.</span>
				</div>
			) : null}
			<div className="sb-req-svc">{r.pets.map((p) => <SbPetBlock p={p} key={p.name} />)}</div>
			{r.note ? <p className="sb-note">“{r.note}”</p> : null}
		</article>
	)
}
export function N2ScrBookings({ on }) {
	const phase = useN2Phases(on, [[1300, 'cursor'], [2300, 'press'], [2700, 'booked']])
	const booked = phase === 'booked'
	return (
		<div className="s-page sb">
			<div className="nm-pagehead" style={{ marginBottom: 15 }}>
				<div className="s-row" style={{ gap: 16 }}>
					<h1>Bookings</h1>
					<div className="nm-tabs">
						<span className="nm-tab on">Requests <em className="nm-tabn">{booked ? 4 : 5}</em></span>
						<span className="nm-tab">Upcoming</span>
						<span className="nm-tab">Waitlist <em className="nm-tabn">4</em></span>
						<span className="nm-tab">History</span>
					</div>
				</div>
				<span className="nm-search sb-search" style={{ width: 230 }}><NIc name="search" size={14} sw={1.8} /><span className="s-search-ph">Search requests</span></span>
			</div>
			<div className="sb-reqlist">
				<SbReq r={SB_REQS[0]} gone={booked} phase={phase} />
				<SbReq r={SB_REQS[1]} />
				<SbReq r={SB_REQS[2]} />
			</div>
			{booked ? (
				<div className="sb-toast">
					<span className="sb-toast-ic"><N2Ic name="check" size={12} sw={2.8} /></span>
					<span className="sb-toast-msg">Booked Waffles · Mon, Jul 20 · 9:00 AM — confirmation sent to Harper</span>
					<span className="sb-toast-undo">Undo</span>
					<span className="sb-toast-x"><N2Ic name="x" size={12} sw={2.2} /></span>
				</div>
			) : null}
		</div>
	)
}

/* ── 4 · Clients & pets — list table → click → Client Details ── */
const SCL_LIST = [
	{ name: 'Alex Morgan', isNew: true, pets: ['Cooper', 'Luna'], next: 'Sep 25, 10:00 AM', phone: '(212) 419-2230', email: 'alexmorgan@gmail.com' },
	{ name: 'Sarah Miller', isNew: true, pets: ['Mr Cuddles'], next: 'Sep 30, 11:00 AM', phone: '(310) 487-5298', email: 'smiller@gmail.com' },
	{ name: 'Maya Thompson', isNew: true, pets: ['Nori', 'Charlie', 'Willow'], next: 'Sep 24, 1:00 PM', phone: '(818) 555-0142', email: 'mayathompson@gmail.com', hit: true },
	{ name: 'Dora Explora', isNew: true, pets: ['Brian'], next: 'Sep 26, 12:30 PM', phone: '(415) 320-0020', email: 'doraexplora@gmail.com' },
	{ name: 'Hugh Jackman', isNew: false, pets: ['Wolverine', 'Logan'], next: null, phone: '(312) 415-2280', email: 'hjackman@gmail.com' },
	{ name: 'Jay Walker', isNew: false, pets: ['Biscuit', 'Pepper', 'Olive'], next: null, phone: '(202) 768-2232', email: 'jaywalker@gmail.com' },
	{ name: 'Tom Brady', isNew: false, pets: ['Bronny'], next: 'Sep 25, 1:00 PM', phone: '(256) 723-9914', email: 'tombrady12@gmail.com' }
]
const SCL_PETS = [
	{ name: 'Nori', species: 'Cat', pic: 'cat', breed: 'Domestic Shorthair', sex: 'Female', weight: '9 lbs', dob: 'Jan 14, 2023',
		notes: [['Medical', 'Healthy; sensitive ears — skip the flush.'], ['Grooming', 'Quick brush-outs — taps out after 20 min.'], ['Personality', 'Shy at drop-off, settles fast.'], ['Veterinarian', 'Sunset Animal Hospital — Dr. Patel']] },
	{ name: 'Charlie', species: 'Dog', pic: 'golden', breed: 'Golden Retriever', sex: 'Male', weight: '64 lbs', dob: 'Mar 2, 2022',
		notes: [['Medical', 'Hip dysplasia — groom on the floor mat.'], ['Grooming', 'Heavy shedder — de-shed every visit.'], ['Personality', 'Mouthy when excited; settles fast.'], ['Veterinarian', 'Westside Veterinary — Dr. Nguyen']] },
	{ name: 'Willow', species: 'Dog', pic: 'poodle', breed: 'Poodle', sex: 'Female', weight: '18 lbs', dob: 'Jun 9, 2021',
		notes: [['Medical', 'Mild grass allergy — flares in spring.'], ['Grooming', 'Mats behind the ears; brush pre-bath.'], ['Personality', 'Gentle; loves the warm towel.'], ['Veterinarian', 'Arroyo Pet Clinic — Dr. Flores']] }
]
/* fun flat pet portraits on vibrant grounds */
export function SclPetPic({ kind, size }) {
	return (
		<span className="scl-petpic" style={size ? { width: size, height: size } : null}>
			{kind === 'cat' ? (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#FFD66B"></rect>
					<path d="M11 16l-2.5-8 7 4.2z" fill="#8E86AE"></path><path d="M29 16l2.5-8-7 4.2z" fill="#8E86AE"></path>
					<path d="M10.4 9.6l5.2 3.1-3.4 2z" fill="#F7B7C9"></path><path d="M29.6 9.6l-5.2 3.1 3.4 2z" fill="#F7B7C9"></path>
					<circle cx="20" cy="24" r="11.5" fill="#A79FC4"></circle>
					<path d="M20 12.5c3 0 5.8 1.2 7.8 3.2" stroke="#8E86AE" strokeWidth="2.4" fill="none" strokeLinecap="round"></path>
					<circle cx="15.8" cy="22.5" r="1.5" fill="#2E2A40"></circle><circle cx="24.2" cy="22.5" r="1.5" fill="#2E2A40"></circle>
					<path d="M18.6 27h2.8l-1.4 1.7z" fill="#E0708F"></path>
					<path d="M20 28.7v1.6M20 30.3c0 .9-.9 1.6-2 1.6M20 30.3c0 .9.9 1.6 2 1.6" stroke="#2E2A40" strokeWidth="1" fill="none" strokeLinecap="round"></path>
					<path d="M6 24.5l6-1M6.5 28l5.6-2M34 24.5l-6-1M33.5 28l-5.6-2" stroke="#FFF" strokeWidth="1.1" strokeLinecap="round"></path>
				</svg>
			) : kind === 'golden' ? (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#7FC8A9"></rect>
					<circle cx="20" cy="22" r="12" fill="#E8AE62"></circle>
					<path d="M8.5 15c-2.6 1.8-3 8.5-.8 11.6 2 .4 4.4-1.2 5-3.4z" fill="#C98F4B"></path>
					<path d="M31.5 15c2.6 1.8 3 8.5.8 11.6-2 .4-4.4-1.2-5-3.4z" fill="#C98F4B"></path>
					<ellipse cx="20" cy="27.5" rx="6.5" ry="5" fill="#F8DCAC"></ellipse>
					<circle cx="15.6" cy="20" r="1.6" fill="#2E2A40"></circle><circle cx="24.4" cy="20" r="1.6" fill="#2E2A40"></circle>
					<path d="M17.6 25.6a2.4 2.4 0 014.8 0c0 1.3-1.1 2.2-2.4 2.2s-2.4-.9-2.4-2.2z" fill="#2E2A40"></path>
					<path d="M18.4 30.5c.4 1.8 2.8 1.8 3.2 0z" fill="#E0708F"></path>
					<circle cx="12.6" cy="24.6" r="1.7" fill="#F3C2C2" opacity=".7"></circle><circle cx="27.4" cy="24.6" r="1.7" fill="#F3C2C2" opacity=".7"></circle>
				</svg>
			) : kind === 'doodle' ? (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#8FB9E6"></rect>
					<circle cx="12" cy="13" r="4.4" fill="#E2AE74"></circle><circle cx="20" cy="11" r="4.8" fill="#E2AE74"></circle><circle cx="28" cy="13" r="4.4" fill="#E2AE74"></circle>
					<circle cx="9.5" cy="22" r="4.4" fill="#D69D62"></circle><circle cx="9" cy="28" r="3.8" fill="#D69D62"></circle>
					<circle cx="30.5" cy="22" r="4.4" fill="#D69D62"></circle><circle cx="31" cy="28" r="3.8" fill="#D69D62"></circle>
					<circle cx="20" cy="23" r="10.5" fill="#EBBE85"></circle>
					<ellipse cx="20" cy="28" rx="5.6" ry="4.2" fill="#F8E3BC"></ellipse>
					<circle cx="16" cy="21" r="1.5" fill="#2E2A40"></circle><circle cx="24" cy="21" r="1.5" fill="#2E2A40"></circle>
					<path d="M17.8 26.4a2.2 2.2 0 014.4 0c0 1.2-1 2-2.2 2s-2.2-.8-2.2-2z" fill="#2E2A40"></path>
					<path d="M18.5 30.6c.4 1.6 2.6 1.6 3 0z" fill="#E0708F"></path>
				</svg>
			) : kind === 'corgi' ? (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#7FD1BE"></rect>
					<path d="M12.5 18L8 5.5l9.5 6.5z" fill="#E8964F"></path><path d="M27.5 18l4.5-12.5L22.5 12z" fill="#E8964F"></path>
					<path d="M10.8 9.2l5 3.6-3.3 2.4z" fill="#F7B7C9"></path><path d="M29.2 9.2l-5 3.6 3.3 2.4z" fill="#F7B7C9"></path>
					<circle cx="20" cy="23" r="11" fill="#E8964F"></circle>
					<path d="M20 12.2c2.2 0 4.3.7 6 1.8l-6 8-6-8c1.7-1.1 3.8-1.8 6-1.8z" fill="#F5D9B8" opacity=".9"></path>
					<ellipse cx="20" cy="27.5" rx="6" ry="4.6" fill="#FBEED8"></ellipse>
					<circle cx="15.4" cy="21" r="1.6" fill="#2E2A40"></circle><circle cx="24.6" cy="21" r="1.6" fill="#2E2A40"></circle>
					<path d="M17.8 25.8a2.2 2.2 0 014.4 0c0 1.2-1 2-2.2 2s-2.2-.8-2.2-2z" fill="#2E2A40"></path>
					<path d="M18.4 30c.4 1.7 2.8 1.7 3.2 0z" fill="#E0708F"></path>
				</svg>
			) : kind === 'cavalier' ? (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#F2A65E"></rect>
					<path d="M9 14c-3.2 2.4-3.6 10-1 13.4 2.6.6 5.6-1.6 6.2-4.4z" fill="#A85B38"></path>
					<path d="M31 14c3.2 2.4 3.6 10 1 13.4-2.6.6-5.6-1.6-6.2-4.4z" fill="#A85B38"></path>
					<circle cx="20" cy="22" r="11" fill="#F7EFDF"></circle>
					<path d="M13.5 15.5a8.8 8.8 0 015-3.2l1 6.2-4.6 1.6z" fill="#B96A42"></path>
					<path d="M26.5 15.5a8.8 8.8 0 00-5-3.2l-1 6.2 4.6 1.6z" fill="#B96A42"></path>
					<circle cx="15.6" cy="20.5" r="1.6" fill="#2E2A40"></circle><circle cx="24.4" cy="20.5" r="1.6" fill="#2E2A40"></circle>
					<path d="M17.9 25.4a2.1 2.1 0 014.2 0c0 1.1-.9 1.9-2.1 1.9s-2.1-.8-2.1-1.9z" fill="#2E2A40"></path>
					<path d="M15 29.4c1.5 1.3 3.1 1.9 5 1.9s3.5-.6 5-1.9" stroke="#D9C9A8" strokeWidth="1.3" fill="none" strokeLinecap="round"></path>
				</svg>
			) : kind === 'lab' ? (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#B7A6E6"></rect>
					<circle cx="20" cy="22" r="12" fill="#8B6544"></circle>
					<path d="M8.8 15.5c-2.4 2-2.7 8.8-.7 11.6 2 .4 4.3-1.3 4.9-3.5z" fill="#6E4C31"></path>
					<path d="M31.2 15.5c2.4 2 2.7 8.8.7 11.6-2 .4-4.3-1.3-4.9-3.5z" fill="#6E4C31"></path>
					<ellipse cx="20" cy="27" rx="6.4" ry="5" fill="#C29A6E"></ellipse>
					<circle cx="15.6" cy="20" r="1.6" fill="#2E2A40"></circle><circle cx="24.4" cy="20" r="1.6" fill="#2E2A40"></circle>
					<path d="M17.6 25.2a2.4 2.4 0 014.8 0c0 1.3-1.1 2.2-2.4 2.2s-2.4-.9-2.4-2.2z" fill="#2E2A40"></path>
					<path d="M18.4 30c.4 1.8 2.8 1.8 3.2 0z" fill="#E0708F"></path>
				</svg>
			) : (
				<svg viewBox="0 0 40 40" width="40" height="40" aria-hidden="true">
					<rect width="40" height="40" fill="#F293BC"></rect>
					<circle cx="14.5" cy="11.5" r="3.4" fill="#F5EDDC"></circle><circle cx="20" cy="10" r="3.8" fill="#F5EDDC"></circle><circle cx="25.5" cy="11.5" r="3.4" fill="#F5EDDC"></circle>
					<circle cx="9.5" cy="21" r="4.2" fill="#EFE3CC"></circle><circle cx="8.8" cy="27" r="3.6" fill="#EFE3CC"></circle>
					<circle cx="30.5" cy="21" r="4.2" fill="#EFE3CC"></circle><circle cx="31.2" cy="27" r="3.6" fill="#EFE3CC"></circle>
					<circle cx="20" cy="22.5" r="10" fill="#F5EDDC"></circle>
					<circle cx="16.2" cy="21" r="1.5" fill="#2E2A40"></circle><circle cx="23.8" cy="21" r="1.5" fill="#2E2A40"></circle>
					<path d="M18 26a2 2 0 014 0c0 1.1-.9 1.9-2 1.9s-2-.8-2-1.9z" fill="#2E2A40"></path>
					<path d="M14.5 30.2c1.6 1.4 3.4 2 5.5 2s3.9-.6 5.5-2" stroke="#D9C9A8" strokeWidth="1.4" fill="none" strokeLinecap="round"></path>
				</svg>
			)}
		</span>
	)
}
function SclPetStack({ pets }) {
	return (
		<span className="scl-petscell">
			<span className="scl-petstack">{pets.slice(0, 3).map((p, i) => <i className="scl-pav" key={p} style={{ zIndex: 3 - i }}><NPaw size={11} /></i>)}</span>
			<em>{pets.length > 1 ? pets.length + ' pets' : pets[0]}</em>
		</span>
	)
}
export function N2ScrClients({ on }) {
	const phase = useN2Phases(on, [[1000, 'cursor'], [2100, 'press'], [2550, 'detail']])
	const detail = phase === 'detail'
	return (
		<div className="s-page scl">
			{!detail ? (
				<React.Fragment>
					<div className="nm-pagehead" style={{ marginBottom: 14 }}>
						<h1>Clients & Pets</h1>
						<div className="s-row" style={{ gap: 10 }}>
							<span className="nm-search soft" style={{ width: 190 }}><NIc name="search" size={14} sw={1.8} /><span className="s-search-ph">Search clients</span></span>
							<span className="nm-btn sm"><NIc name="plus" size={13} sw={2.1} />New client</span>
						</div>
					</div>
					<div className="nm-card scl-tablecard">
						<table className="scl-table">
							<thead><tr><th>Client name <NIc name="sort" size={11} sw={1.6} /></th><th>Pets</th><th>Next visit <NIc name="sort" size={11} sw={1.6} /></th><th>Phone</th><th>Email</th><th className="scl-th-act">Actions</th></tr></thead>
							<tbody>
								{SCL_LIST.map((c) => (
									<tr key={c.name} className={'scl-row' + (c.hit && phase === 'press' ? ' hit' : '')}>
										<td><span className="scl-name">{c.name}{c.isNew ? <span className="nm-flag first">New</span> : null}</span></td>
										<td><SclPetStack pets={c.pets} /></td>
										<td>{c.next ? <span className="scl-next">{c.next}</span> : <span className="scl-dash">—</span>}</td>
										<td className="scl-mut">{c.phone}</td>
										<td className="scl-mut">{c.email}</td>
										<td><span className="scl-acts"><i className="nm-iconbtn"><NIc name="pencil" size={12} sw={1.7} /></i><i className="nm-iconbtn danger"><NIc name="trash" size={12} sw={1.7} /></i></span></td>
									</tr>
								))}
							</tbody>
						</table>
						<N2Cursor show={phase === 'cursor' || phase === 'press'} press={phase === 'press'} x="118px" y="150px" />
					</div>
				</React.Fragment>
			) : (
				<React.Fragment>
					<div className="nm-pagehead scl-dethead" style={{ marginBottom: 4 }}>
						<div className="s-row" style={{ gap: 9 }}><span className="nm-iconbtn"><NIc name="chevl" size={14} sw={1.9} /></span><h1>Client Details</h1></div>
						<span className="nm-btn sm"><NIc name="plus" size={13} sw={2.1} />Add pet</span>
					</div>
					<div className="scl-detail">
						<div className="nm-card pad scl-sum">
							<div className="s-row" style={{ gap: 8 }}>
								<strong className="scl-sum-name">Maya Thompson</strong><span className="nm-flag first">New</span>
								<span className="nm-iconbtn" style={{ marginLeft: 'auto' }}><NIc name="pencil" size={12} sw={1.7} /></span>
							</div>
							<span className="scl-since">Client since Aug 12, 2025</span>
							<div className="scl-stats">
								<span className="scl-stat"><strong>5</strong><em>Total bookings</em></span>
								<span className="scl-stat"><strong>2</strong><em>Completed</em></span>
							</div>
							<div className="scl-btns">
								<span className="nm-btn sm"><NIc name="calendar" size={13} sw={1.8} />Book appointment</span>
								<span className="nm-btn-ghost sm"><NIc name="messages" size={13} sw={1.7} />Message</span>
								<span className="nm-btn-ghost sm"><NIc name="agreements" size={13} sw={1.7} />Send agreements</span>
							</div>
							<div className="scl-info">
								<span className="nm-overline">Information</span>
								<span><NIc name="phone" size={13} sw={1.7} />(818) 555-0142</span>
								<span><NIc name="mail" size={13} sw={1.7} />mayathompson@gmail.com</span>
								<span><NIc name="pin" size={13} sw={1.7} />2500 Wilshire Blvd, Los Angeles, CA</span>
							</div>
							<div className="scl-nextsec">
								<span className="nm-overline">Next Appointment</span>
								<div className="scl-up">
									<div className="s-row" style={{ justifyContent: 'space-between' }}><strong>Sep 24, 2025</strong><span>1:00 – 2:00 PM</span></div>
									<span className="scl-up-pet"><NIc name="dot" size={8} />Charlie · Dog grooming</span>
									<span className="scl-up-add">+ Nail trim</span>
									<span className="scl-up-add">+ Teeth brushing</span>
									<div className="s-row scl-up-foot"><NIc name="user" size={11} sw={1.7} /><span>Mike Chen</span><strong>$95</strong></div>
								</div>
							</div>
						</div>
						<div className="scl-main">
							<div className="nm-tabs scl-tabs"><span className="nm-tab on">Pets</span><span className="nm-tab">History</span></div>
							<div className="scl-grid">
								{SCL_PETS.map((p, i) => (
									<div className="nm-card pad scl-pet" key={p.name} style={{ '--d': (0.1 + i * 0.09) + 's' }}>
										<span className="nm-iconbtn scl-pet-edit"><NIc name="pencil" size={12} sw={1.7} /></span>
										<div className="s-row" style={{ gap: 10 }}>
											<SclPetPic kind={p.pic} />
											<div className="scl-pet-id"><strong>{p.name}</strong><span>{p.species}</span></div>
										</div>
										<div className="scl-keys">
											<span className="scl-key"><em>Breed</em><strong>{p.breed}</strong></span>
											<span className="scl-key"><em>Sex</em><strong>{p.sex}</strong></span>
											<span className="scl-key"><em>Weight</em><strong>{p.weight}</strong></span>
											<span className="scl-key"><em>Birthday</em><strong>{p.dob}</strong></span>
										</div>
										{p.notes.map(([k, v]) => <div className="scl-note" key={k}><em>{k}</em><span>{v}</span></div>)}
										<span className="scl-notes-toggle">See full notes</span>
									</div>
								))}
							</div>
						</div>
					</div>
				</React.Fragment>
			)}
		</div>
	)
}

/* ── 5 · Messages + AI booking — Renee/Cooper thread ── */
const SM_LIST = [
	{ ini: 'RC', name: 'Renee Cho', last: 'Late morning would be ideal, around 11…', time: '9:49 AM', unread: true },
	{ ini: 'KT', name: 'Kevin Tran', last: 'Reminder sent · Lily & Milo · Mon 8:30 AM', time: 'Tue', auto: true },
	{ ini: 'GL', name: 'Grace Lin', last: 'Thanks! See you next time.', time: 'Mon' },
	{ ini: 'AD', name: 'Amy Diaz', last: 'C', time: 'Mon', confirmed: true }
]
export function N2ScrMessages({ on }) {
	const phase = useN2Phases(on, [[600, 'b1'], [1500, 'b2'], [2500, 'cursor1'], [3300, 'press1'], [3750, 'modal'], [5700, 'cursor2'], [6500, 'press2'], [7000, 'booked']])
	const P = ['idle', 'b1', 'b2', 'cursor1', 'press1', 'modal', 'cursor2', 'press2', 'booked']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const modalUp = at('modal') && !at('booked')
	return (
		<div className="s-page sm2">
			<div className="sm-split">
				<div className="nm-card sm-list">
					<div className="sp-search"><span className="nm-search soft"><NIc name="search" size={14} sw={1.8} /><span className="s-search-ph">Search messages…</span></span></div>
					{SM_LIST.map((c, i) => (
						<div className={'sm-row' + (i === 0 ? ' sel' : '')} key={c.ini}>
							<span className="nm-avatar">{c.ini}</span>
							<div className="sm-row-tx">
								<div className="s-row"><strong>{c.name}</strong><span className="sm-time">{c.time}</span></div>
								<span className="sm-last">{c.confirmed ? 'Confirmed with a “C” — all set' : c.last}</span>
							</div>
							{c.unread ? <i className="sm-dot"></i> : null}
						</div>
					))}
				</div>
				<div className="nm-card sm-thread">
					<div className="sm-thead">
						<span className="nm-avatar" style={{ color: 'var(--primary-deep, #5F4EC2)', fontSize: 12.5, fontWeight: 800, lineHeight: 1 }}>RC</span>
						<div><strong style={{ display: 'block', color: 'var(--text, #2E2A40)' }}>Renee Cho</strong><span className="sm-sub" style={{ color: 'var(--muted, #8B85A4)' }}>(415) 555-0173 · Cooper’s person</span></div>
						<span className="sm-aiwrap">
							<span className={'sm-aibtn' + (phase === 'press1' ? ' pressed' : '')}><NIc name="spark" size={13} sw={2} />Create appointment<i className="sm-aibadge">AI</i></span>
							<N2Cursor show={phase === 'cursor1' || phase === 'press1'} press={phase === 'press1'} x="92px" y="17px" />
						</span>
					</div>
					<div className="sm-scroll">
						<span className="sm-day">Today</span>
						<div className={'sm-bub client' + (at('b1') ? ' in' : '')}>
							<p>Hi! Do you have any openings this Saturday to get Cooper groomed? He’s a Labrador — needs a full groom and probably a nail trim too.</p>
							<span>9:48 AM</span>
						</div>
						<div className={'sm-bub client' + (at('b2') ? ' in' : '')}>
							<p>Late morning would be ideal, around 11 if you have it.</p>
							<span>9:49 AM</span>
						</div>
						{at('booked') ? (
							<React.Fragment>
								<div className="nm-note ok sm-booked"><NIc name="checkc" size={14} sw={1.9} /><span><strong>Booked — Sat, Jun 20 · 11:00 AM.</strong> Added to the calendar & confirmation sent.</span></div>
								<div className="sm-bub biz in">
									<p>You’re all set! Cooper is booked for Saturday, Jun 20 at 11:00 AM — full groom with a nail trim. We’ll text a reminder the day before.</p>
									<span>Sent just now · Delivered</span>
								</div>
							</React.Fragment>
						) : null}
					</div>
					<div className="sm-composer">
						<span className="sm-input">Reply to Renee…</span>
						<span className="sm-send"><N2Ic name="send" size={14} sw={2} /></span>
					</div>
				</div>
			</div>
			{modalUp ? (
				<div className="sm-scrim">
					<div className="sm-modal">
						<div className="sm-modal-head">
							<span className="sm-modal-ic"><NIc name="spark" size={14} sw={2} /></span>
							<div><strong>Create appointment <i className="sm-aibadge">AI</i></strong><span>Auto-filled from Renee’s messages · review &amp; book</span></div>
							<span className="nm-iconbtn sm-modal-x"><NIc name="x" size={12} sw={1.9} /></span>
						</div>
						<div className="sm-mbody">
							<div className="sm-ainote">AI-tagged fields were pulled from the conversation — adjust anything before booking.</div>
							<div className="sm-msec">
								<span className="sm-msec-t">When<i className="sm-aitag">AI</i></span>
								<div className="sm-fpair">
									<span className="sm-fld"><NIc name="calendar" size={13} sw={1.7} />Sat, Jun 20<i className="chev"><NIc name="chevron" size={11} sw={1.8} /></i></span>
									<span className="sm-fld"><NIc name="clock" size={13} sw={1.7} />11:00 AM<i className="chev"><NIc name="chevron" size={11} sw={1.8} /></i></span>
								</div>
							</div>
							<div className="sm-msec">
								<span className="sm-msec-t">Client details<i className="sm-aitag">AI</i></span>
								<span className="sm-fld ro"><NIc name="user" size={13} sw={1.7} />Renee Cho</span>
								<span className="sm-fld"><NPaw size={13} />Cooper · Labrador Retriever<i className="chev"><NIc name="chevron" size={11} sw={1.8} /></i></span>
							</div>
							<div className="sm-msec">
								<span className="sm-msec-t">Service details<i className="sm-aitag">AI</i></span>
								<span className="sm-fld"><NIc name="services" size={13} sw={1.7} />Full Groom — Large · $110 · 75m<i className="chev"><NIc name="chevron" size={11} sw={1.8} /></i></span>
								<span className="sm-fld"><NIc name="plus" size={13} sw={1.9} />Nail Trim · $12 · 15m<i className="chev"><NIc name="chevron" size={11} sw={1.8} /></i></span>
							</div>
							<span className="sm-ends">Ends at: <strong>12:30 PM</strong> · $122</span>
						</div>
						<div className="sm-mfoot">
							<span className="nm-btn-ghost sm">Cancel</span>
							<span className="sm-mgo">
								<span className={'nm-btn sm' + (phase === 'press2' ? ' pressed' : '')}><NIc name="calendar" size={13} sw={1.8} />Create appointment</span>
								<N2Cursor show={phase === 'cursor2' || phase === 'press2'} press={phase === 'press2'} x="88px" y="15px" />
							</span>
						</div>
					</div>
				</div>
			) : null}
		</div>
	)
}
